import { AfterViewInit, Component, ComponentRef, DestroyRef, HostListener, Inject, NgZone, OnDestroy, OnInit, ViewChild, ViewContainerRef } from '@angular/core';

import { Platform, PopoverController, ToastController, MenuController, IonModal, ModalController } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { UserBasicInfo, UserBasicService } from './shared/services/user-basic.service';
import { TranslateService } from '@ngx-translate/core';
import { ChangeLanguageService } from './shared/services/change-language.service';
import { Plugins } from '@capacitor/core';
import { AuthenticationService } from './shared/services/authentication.service';
import { RegisterService } from './shared/services/register.service';
import { ThemeService } from './shared/services/theme.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { distinctUntilChanged, filter, finalize } from 'rxjs/operators';
import { animate, state, style, transition, trigger } from '@angular/animations';
import Pushy from 'pushy-sdk-web';
import { PushyService } from './shared/services/pushy.service';
import { HelpersService } from './shared/services/helpers.service';
import { NotificationsStorageService } from './shared/services/storage/notifications-storage.service';
import { AppCacheStorageService } from './shared/services/storage/app-cache-storage.service';
import { DataService } from './shared/services/send-data.service';
import { PageURL } from './pages/pages';
import { DynamicPath } from './shared/services/dynamic-path.service';
import { ConsoleToggleService } from './shared/services/console-toggle.service';
import { EnvironmentService, TagManagerServiceProvider } from './shared/services/GoogleTagManager/googleTagManager.service.provider';
import { GTMService } from './shared/services/GoogleTagManager/googleTagManager.service';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { APP_CONFIG, AppConfig } from './shared/services/config-initialization.service';
import { ThemeControllerService } from './shared/services/theme-controller.service';
import { CookieService } from 'ngx-cookie-service';
import { FullStory, init} from '@fullstory/browser';
import { RefreshmentTimeService } from './pages/refreshment-time/refreshment-time.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RegistrationNavigationLoaderService } from './shared/services/registration-navigation-loader.service';
import { SessionTimeoutService } from './shared/services/session-timeout.service';

const { Device } = Plugins;

export const apiURLs = {
  getInitialData: '/content/login/initial'
};

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.scss'],
    animations: [
        trigger('toggleText', [
            state('true', style({ opacity: 1 })),
            state('false', style({ opacity: 0 })),
            transition('false <=> true', animate(0))
        ]),
        trigger('toggleMenu', [
            state('true', style({ width: '260px' })),
            state('false', style({ width: '70px' })),
            transition('false <=> true', animate(100))
        ])
    ],
    providers: [
        EnvironmentService,
        TagManagerServiceProvider
    ],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy, AfterViewInit {
  readonly Math = Math;
  registrationNavigationLoading = false;
  public selectedIndex = 0;
  public selectedIndexSub;
  public selectedIndexFooter;
  private fullStoryClient: any;
  public appPages = [
    {
      id: 0,
      htmlId: 'dashboard',
      title: 'menu_Dashboard',
      url: '/dashboard',
      open: false, //required to initialize the object with open attribute for future use
      children: [], //required to initialize the object with children attribute for future use
      // icon: 'home'
      icon_active: 'wb-accounts-active.svg',
      icon_inactive: 'wb-accounts-inactive.svg',
      icon_inactive_dark: 'wb-accounts-inactive-dark.svg'
    },
    {
      id: 1,
      htmlId: 'payments',
      title: 'bottomNavigation_payments',
      url: '/payments',
      // icon: 'wallet'
      icon_active: 'wb-payments-active.svg',
      icon_inactive: 'wb-payments-inactive.svg',
      icon_inactive_dark: 'wb-payments-inactive-dark.svg'

    },
    {
      id: 2,
      htmlId: 'cashback',
      title: 'menu_BiCashback',
      url: '/cashback',
      icon_active: 'wb-bicashback-active.svg',
      icon_inactive: 'wb-bicashback-inactive.svg',
      icon_inactive_dark: 'wb-bicashback-inactive-dark.svg'
    },
    {
      id: 3,
      htmlId: 'reports',
      title: 'menu_Reports',
      url: '/reports',
      icon_active: 'wb-bireports-active.svg',
      icon_inactive: 'wb-bireports-inactive.svg',
      icon_inactive_dark: 'wb-bireports-inactive-dark.svg'
    },
    {
      // View more page must be ID 5 or changed also in method openPopup()
      id: 4,
      htmlId: 'viewMore',
      title: 'bottomNavigation_more',
      url: '/view-more',
      // icon: 'ellipsis-horizontal-circle',
      icon_active: 'wb-viewmore-active.svg',
      icon_inactive: 'wb-viewmore-inactive.svg',
      icon_inactive_dark: 'wb-viewmore-inactive-dark.svg'
    }
  ];
  public appBottomPages = [];

  userLoggedIn: boolean;
  authSub: Subscription;
  themeSub: Subscription;
  selectedTheme: string;
  logoSrc: string;
  userInfo: UserBasicInfo;
  userBasicSub: Subscription;
  pagesChecked: boolean;
  langSub: Subscription;
  language: string;
  availableLangsSub: Subscription;
  availableLanguages: any[];
  langDirection: string = 'ltr';
  sharedSwitchLang: any;
  sharedLogout: any;
  sharedOpenTools: any;
  deviceLanguage: any;
  showActions: boolean = false;
  nextAction: any;
  verifyEmailMenuDisable: boolean = false;
  foundNextAction: boolean = false;
  cashbackApproved: boolean = false;
  menuArrow: string;
  menuOpen: boolean = true;
  showPop: boolean = false;
  splitUrl: any;
  mobileMenu: boolean = false;
  submenuOpen: boolean = false;
  activePage: any;
  openBottomModal: boolean = false;
  mobileVersion: boolean = false;
  selectedSubMenu: any;
  activeUrl: string;
  showMenu: boolean= false;
  PageURL: typeof PageURL = PageURL;
  @ViewChild('modalBottom') bottomModal: IonModal;
  @ViewChild('salesforceChatHost', { read: ViewContainerRef }) salesforceChatHost?: ViewContainerRef;
  currentLang: string;
  languageCodes: any = ['en','ar','fa','fr','pl','es','ja','zh','ko','id','th','ms','vi'];
  maintenanceModeOn: boolean = false;
  toast: HTMLIonToastElement;

  fontSizes: any = {en:14,ar:14,fa:14,fr:14,pl:14,es:13,ja:11,zh:14,ko:14,id:14,th:13,ms:14,vi:10,pt:14};
  fontSize: any = 14;
  isLoggedIn: boolean = false;
  redirectUrlDetails: string = '';
  menuLogoSrc: string = '';
  private notificationListenerInitialized = false;
  private salesforceChatComponentRef?: ComponentRef<any>;
  private salesforceChatComponentLoaded = false;
  private pushNotificationListenerRegistered = false;
  hasFullStoryInitialized: boolean = false;

  constructor(
    private platform: Platform,
    private router: Router,
    public readonly translate: TranslateService,
    private readonly changeLangService: ChangeLanguageService,
    public readonly toastController: ToastController,
    public readonly popoverController: PopoverController,
    public readonly modalController: ModalController,
    private readonly auth: AuthenticationService,
    private readonly userBasicService: UserBasicService,
    private readonly organizationService: RegisterService,
    private readonly theme: ThemeService,
    private readonly pushy: PushyService,
    private readonly helpers: HelpersService,
    private menuCtrl: MenuController,
    private readonly notificationService: NotificationsStorageService,
    private ngZone: NgZone,
    private dataSource: DataService,
    private readonly cache: AppCacheStorageService,
    private route: ActivatedRoute,
    private readonly dynamicPath: DynamicPath,
    private consoleToggleService: ConsoleToggleService,
    private readonly googleTagManagerService: GTMService,
    private readonly http: HttpClient,    
    private readonly regService: RegisterService,
    private readonly themeControllerService: ThemeControllerService,
    private readonly refreshmentTimeService: RefreshmentTimeService,
    private readonly destroyRef: DestroyRef,
    private readonly registrationNavigationLoader: RegistrationNavigationLoaderService,
    readonly sessionTimeout: SessionTimeoutService,
    @Inject(APP_CONFIG) private config: AppConfig,
  ) {
    this.registrationNavigationLoader.active$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(active => this.registrationNavigationLoading = active);
    this.selectedTheme = this.theme.getActiveThemeValue();
    this.logoSrc = this.resolveLogoSrc(this.selectedTheme);
    this.themeControllerService.getThemeBasedOnDomain(this.config.cid,this.config.bucketUrl);
    this.consoleToggleService.disableConsoleInProduction();
    this.initializeApp();
  }

  async initTagManager() {
    if(this.config.production || this.config.uat) {
      if ((window as any).__wbGtmInitialized) {
        return;
      }
      (window as any).__wbGtmInitialized = true;
      //const {TagManagerModule} = await import("./shared/modules/googleTagModule.module")
      // let module = new NgModule()
      // module.imports.push(TagManagerModule)
      this.loadScript();
    }
  }

  getInitialContent(): Observable<any> {
    return this.http.get(this.config.restApiUrl + apiURLs.getInitialData);
  }

  initializeApp() {
    this.platform.ready().then(() => {
      this.getInitialContent().subscribe(data => {
        this.regService.setOrganizationCombinations(data.organizationsCombinations);
        this.theme.testDevicePreference(false);
      });
    });
  }

  loadScript() {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.innerHTML = "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='" + this.config.googleManagerPath + "?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','"+this.config.googleManagerId+"')";
    const head = document.getElementsByTagName('head')[0];
    if (head !== null && head !== undefined) {
      document.head.appendChild(script);
    }
  }
  
  checkSafari() {
    this.platform.ready().then(() => {
      const ua = navigator.userAgent;

      const isSafari =
        /Safari/i.test(ua) &&
        !/CriOS|FxiOS|EdgiOS|OPiOS|Chrome|Chromium|Android/i.test(ua);

      if (isSafari) {
        document.documentElement.classList.add('safari');
      }
    });
  }

  ngOnInit() {
    this.sessionTimeout.warningVisible$.pipe(distinctUntilChanged(),filter(visible => visible),takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        void this.closeActivePopupsForSessionTimeout();
    });
    this.auth.checkStorage().then(authenticated => {
      if (authenticated) this.sessionTimeout.start();
    });
    this.checkSafari();
    this.googleTagManagerService.initGtmDom();

    this.langInit();
    this.initTagManager();
    this.scheduleNonCriticalStartupWork(() => {
      this.fullStoryInit();
    });

    // Keep query-param handling lightweight to avoid recreating language subscriptions.
    this.route.queryParams
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(params => {
      if(params['lang']){
        setTimeout(() => {
          this.language = params['lang'];
          this.changeLangService.setLang(this.language);
        },100)
      }
      if(params['returnUrl']) {
        this.dynamicPath.setPath(params['returnUrl'] + (params['lang'] ? '?lang='+ params['lang'] : ''))
      }
    })
    this.router.events.pipe(

      filter((e): e is NavigationEnd => e instanceof NavigationEnd),
      takeUntilDestroyed(this.destroyRef)
      ).subscribe(e => this.handleNavigationEnd(e));
    this.authSub = this.auth.authenticationState
    .pipe(distinctUntilChanged(), takeUntilDestroyed(this.destroyRef))
      .subscribe(res => {  
      this.userLoggedIn = res;
      //console.log('res in APP component:', res);
      if (res) {
        setTimeout(()=>{
          // this.theme.getSavedTheme();
          this.userBasicService.getBasicInfo().subscribe();
          this.getUserInfo();
          this.setLanguage(this.language);
          this.refreshmentTimeService.getKycStatus().subscribe();
        }, 0);
      } else {
        this.isLoggedIn = false;
        this.showMenu = false;
        this.mobileMenu = false;
        this.menuOpen = true;
        this.submenuOpen = false;
        this.menuCtrl.enable(false);
        this.clearSalesforceChatComponent();
        this.changeLangService.setAllLanguages();
      }
    });

    this.themeSub = this.theme.getActiveTheme()
    .pipe(distinctUntilChanged(), takeUntilDestroyed(this.destroyRef))
    .subscribe(val => {
      if (!val) {
        return;
      }
      this.selectedTheme = val;
    });

    this.dataSource.data
    .pipe(takeUntilDestroyed(this.destroyRef)).subscribe((responseData) => {
      //console.log('response' , responseData);
      this.showPop = responseData;
    })
  }

  private scheduleNonCriticalStartupWork(task: () => void): void {
    const idleWindow = window as Window & {
      requestIdleCallback?: (callback: IdleRequestCallback, options?: IdleRequestOptions) => number;
    };

    if (idleWindow.requestIdleCallback) {
      idleWindow.requestIdleCallback(() => task(), { timeout: 2000 });
      return;
    }

    setTimeout(task, 0);
  }
  
  fullStoryInit() {
    if (this.config.fsf === 'true') {
      this.ensureFullStoryLoaded().then((fullStory) => {
        if (!fullStory?.init) {
          return;
        }

        fullStory.init({
          orgId: this.config.fsid,
          host: 'eu1.fullstory.com',
          appHost: 'app.eu1.fullstory.com'
        });
      });
    }
  }

  private ensureFullStoryLoaded(): Promise<any> {
    if (!this.fullStoryClient) {
      this.fullStoryClient = import('@fullstory/browser').then((module: any) => ({
        FullStory: module.FullStory ?? module.default ?? module,
        init: module.init ?? module.default?.init
      }));
    }

    return this.fullStoryClient;
  }
  
   naviagationEnd(){
    
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        console.log('navigation end' , event);
        /*this.cache.load('feedier').then((data) => {
          console.log('cache feedier exist' , data);
          if(data != null){
            console.log('feedier exist, gogole tag manager push tag' , data, event.url);
            this.googleTagManagerService.feedier(data,event.url);
          }
          
        });*/
        this.loadCacheWithRetry()
        .then((data) => {
          console.log('cache feedier exist:', data);
          this.googleTagManagerService.feedier(data, event.url,this.currentLang);
        })
        .catch((error) => {
          console.error('Failed to load feedier data:', error);
        });
      }
    });
  }
  
  loadCacheWithRetry(retries = 2) {
    return new Promise((resolve, reject) => {
      this.cache.load('feedier').then((data) => {
        if (data !== null && typeof data !== 'undefined') {
          resolve(data);
        } else if (retries > 0) {
          console.log(`Data is null, retrying... (${retries} attempts left)`);
          setTimeout(() => {
            this.loadCacheWithRetry(retries - 1).then(resolve).catch(reject);
          }, 1000); // Retry after a 1-second delay
        } else {
          reject(new Error('Data is null after retrying'));
        }
      }).catch(reject);
    });
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if(this.showMenu){
      //if simulator/device is changed, it must be refreshed to update the platfroms
      //e,g, open iphone on chrome dev tools, platfors are set for iphone
      //if you switch to ipad in dev tools the platforms remain those of the iphone until you refresh
      //This scenario should be unrealistic in real life
      if(event.target.innerWidth < 768 || (this.platform.platforms().includes('mobile') && !this.platform.platforms().includes('tablet') && event.target.innerWidth < 916)){
        this.mobileMenu = true;
      } else {
        if( event.target.innerWidth <= 1460){
          this.menuOpen = false;
        } else {
          this.menuOpen = true;
        }
        this.mobileMenu = false;
      }
    }
  }

  closerModal(){
    this.showPop = false;
  }

  private async closeActivePopupsForSessionTimeout(): Promise<void> {
    this.showPop = false;
    for (let attempts = 0; attempts < 10; attempts++) {
      const overlay = await this.modalController.getTop();
      if (!overlay || overlay.classList.contains('session-timeout-modal')) break;
      await overlay.dismiss(undefined, 'session-timeout');
    }

    for (let attempts = 0; attempts < 10; attempts++) {
      const overlay = await this.popoverController.getTop();
      if (!overlay) break;
      await overlay.dismiss(undefined, 'session-timeout');
    }
  }

  ngAfterViewInit() { 
    void this.loadSalesforceChatComponent();
    void this.cacheActivePage(this.router.url);
  }
  

  ngOnDestroy() {
    this.authSub.unsubscribe();
    this.themeSub.unsubscribe();
    // this.pushSub.unsubscribe();
    this.userBasicSub.unsubscribe();
    // this.disconnectSubscription.unsubscribe();
    // this.connectSubscription.unsubscribe();
  }

  openPopup(page){
    this.userInfo.actions.forEach(action => {
      //console.log(action)
       if ((action.id == "VerifyEmail") && !(page.id == 4 && page.url == '/view-more')) {
        this.router.navigate(['/dashboard']);
        this.emailVerifyPopover(this.translate.instant(action.text), this.userInfo.Email);
      }
    });
  }


  async emailVerifyPopover(text:string, userEmail:any) {
    const { EmailVerifyPopoverComponent } = await import('./shared/components/notifications/email-verify-popover/email-verify-popover.component');
    const popover = await this.popoverController.create({
      component: EmailVerifyPopoverComponent,
      componentProps: {
        text: text,
        userEmail: userEmail
      },
      cssClass: 'email-verify-popover'
    });
    return await popover.present();
  }

  private handleNavigationEnd(event: NavigationEnd): void {
    if(event.url?.includes('/verifyemail/') || event.url?.includes('/welcome') || event.url?.includes('/register') || event.url?.includes('/maintenance') || event.url?.includes('/recovertoken/token') || event.url?.includes('/version') || event.url?.includes('/forgot-password') || event.url?.includes('/pswdset')){
      this.menuCtrl.enable(false);
      this.mobileMenu = false;
      this.showMenu = false;
    } else {
      this.showMenu = true;
      this.menuCtrl.enable(true);
      //if simulator/device is changed, it must be refreshed to update the platfroms
      //e,g, open iphone on chrome dev tools, platfors are set for iphone
      //if you switch to ipad in dev tools the platforms remain those of the iphone until you refresh
      //This scenario should be unrealistic in real life
      if(window.innerWidth < 768 || (this.platform.platforms().includes('mobile') && !this.platform.platforms().includes('tablet') && window.innerWidth < 916)){
        this.mobileMenu = true;
      }
      if( window.innerWidth <= 1460){
        this.menuOpen = false;
      }
    }

    this.activeUrl = event.url;
    void this.cacheActivePage(event.url);
  }

  private async cacheActivePage(url: string): Promise<void> {
    const activeUrl = await this.cache.load('activePage');

    if (activeUrl == url) {
      this.appPages.forEach(page => {
        if (page.children) {
          page.children.forEach(child => {
            if (child.url == url) {
              child.open = true;
              page.open = true;
            }
          });
        }
      });
      return;
    }

    await this.cache.save('activePage', url);
  }

  navigateToPage(url: string) {
    this.router.navigate([url]);
  }

  private resolveLogoSrc(theme: string): string {
    //assets/images/wb-logo-min.png
    let cid = this.config.cid;
    switch(cid){
      case 'MWP105':
        if (theme == 'light') {
          return `${this.config.bucketUrl}/assets/images/wb-dark-logo.svg`;
        } 
        if (theme == 'dark') {
          return `${this.config.bucketUrl}/assets/images/wb-white-logo-02.svg`;
        }
        break;
      case 'MUH864':
      case 'CUH689':
        if (theme == 'light') {
          return `${this.config.bucketUrl}/assets/images/wb-dark-logo.svg`;
        } 
        if (theme == 'dark') {
          return `${this.config.bucketUrl}/assets/images/wb-white-logo-02.svg`;
        }
        break;
      case 'WBI483':
        if (theme == 'light') {
          return `${this.config.bucketUrl}/assets/images/wbi-menu-darklogo.svg`;
        } 
        if (theme == 'dark') {
          return `${this.config.bucketUrl}/assets/images/wbi-menu-whitelogo-01.svg`;
        }
        break;
      case 'MWM230':
        if (theme == 'light') {
          return `${this.config.bucketUrl}/assets/images/wm.svg`;
        } 
        if (theme == 'dark') {
          return `${this.config.bucketUrl}/assets/images/wm-dark.svg`;
        }
        break;
      default:
        if (theme == 'light') {
          return `${this.config.bucketUrl}/assets/images/logo-placeholder-image.png`;
        } 
        if (theme == 'dark') {
          return `${this.config.bucketUrl}/assets/images/logo-placeholder-image.png`;
        }
        break;      
    }
  }

  getDeviceLanguage(){
    let devLang = navigator.language.toLowerCase();
    this.language = 'en';
    this.languageCodes.forEach(lang => {
      if (devLang?.includes(lang)) {
        //console.log("supported: "+devLang);
        if (lang == 'ms') lang = 'my';
        this.language = lang;
      }
    });
    this.setLanguage(this.language);
    this.changeLangService.setLang(this.language);
  }

  langInit() {
    this.translate.setDefaultLang('en');
    this.availableLangsSub = this.changeLangService.getAvailableLangs().subscribe(langList => {
      this.availableLanguages = langList;
      //console.log('LANG LIST', langList);
      this.setLanguage(this.language);
    });

    this.changeLangService.isLanguageLoaded().subscribe( loaded => {
      if(loaded){
        this.langSub = this.changeLangService.getCurrentLang().subscribe(lang => {     
          if (lang) {
            this.currentLang = lang;
            //console.log(`retrieved language from storage: ${lang}`);
            //alert(`retrieved language from storage: ${lang}`)
            this.setLanguage(lang);
            for (const [key, value] of Object.entries(this.fontSizes)) {
              if (key == lang) {
                this.fontSize = value + 'px';
                break;
              }
            }
          } else { // no lang in storage, so it's the first use of the app
            //console.log(`NO language from storage.`);
            this.getDeviceLanguage();       
          }
        });
      }
    });
  }

  setLanguage(lang: string, deviceLang?: any): void {
    if (lang && this.availableLanguages.length > 0) {
      let langAllowed;
      this.availableLanguages.forEach(language => {
        if (lang === language.code) {  
          langAllowed = true;       
        }
      });

      if (langAllowed) {
        //console.log('LANGUAGE IS ALLOWED');
        this.language = lang;  

        this.translate.use(this.language)
          .pipe(
            finalize(() => {
              window.portalTranslationsReady?.();
              console.log('[Portal] Language activation finalized.');
            })
          )
          .subscribe({
            next: () => {
              console.log('[Portal] Language ready:', this.language);
              window.portalTranslationsReady?.();
            },
            error: error => {
              console.error('[Portal] Failed to activate language:', error);
            }
          });
        console.log('[Portal] portalReady called setLanguage');
        if (deviceLang) this.changeLangService.setLang(this.language);

        if (lang == 'ar' || lang == 'fa') {
          this.langDirection = 'rtl';
          this.menuArrow = 'chevron-forward-outline';
        } else {
          this.langDirection = 'ltr';
          this.menuArrow = 'chevron-back-outline';
        }    
      } else {
        //console.log('LANGUAGE IS NOT ALLOWED');
        let msg = 'The selected language is not supported by this organisation. Language is set to English.';
        this.presentToastLang(this.translate.instant(msg));
        this.language = 'en';
        this.changeLangService.setLang(this.language);
      }
    }  
  }

  getUserInfo(): void {
    this.userBasicSub = this.userBasicService.basicInfo().subscribe(
      (info: UserBasicInfo) => { 
        if (info) {
          this.userInfo = info;
           this.isLoggedIn = true;
           if(this.userInfo?.feedier != null){
            this.cache.save('feedier', this.userInfo?.feedier);  
          }

          if(this.config.fsf === 'true' && !this.hasFullStoryInitialized) {
            this.ensureFullStoryLoaded().then((fullStory) => {
              if (fullStory?.FullStory) {
                fullStory.FullStory('setIdentity', {
                  uid: this.userInfo.Id.toString(),
                  properties:{
                    displayName: this.userInfo.Id.toString()
                  }
                });
                this.hasFullStoryInitialized = true;
                console.log('FullStory identify with uid:', this.userInfo.Id);
              }
            });
          }
          
           void this.loadSalesforceChatComponent();
          //console.log('userInfo',this.userInfo);
          /* TODO: NEW ORGANIZATION */
           this.cashbackApproved = this.userInfo?.Verified && this.userInfo?.BIApproved 
            && this.userInfo?.StatusBI && !this.userInfo?.Terminated && this.userInfo?.BICashbackEligible
          for (let action of this.userInfo?.web_actions) {
            if (action.finished == false) {
              this.nextAction = action;
              this.foundNextAction = true;
              break;
            }
          }
          /* console.log('test' , window.location.pathname , this.cashbackApproved) */
          if(window.location.pathname == '/cashback' && this.cashbackApproved) {
            this.router.navigate(['/cashback']);
          } else if(window.location.pathname == '/cashback' && this.cashbackApproved == false) {
            this.router.navigate(['/dashboard']);
          }
          
         /*  this.auth.redirectPortal('old' , 'bi').subscribe(res => {
            if(res){
              this.appBottomPages = [];
              this.redirectUrlDetails = res['url'].split('.com/')[1];
              let shortUrlWithoutDetails = res['url'].split(this.redirectUrlDetails)[0];
              this.appBottomPages.push(
                {
                  title: 'Classic BI Portal',
                  url: shortUrlWithoutDetails,
                  icon_active: 'wb-classic-redirect.svg',
                  icon_inactive: 'wb-classic-redirect.svg',
                  icon_inactive_dark: 'wb-classic-redirect-dark.svg',
                  action: 'classic-bi-portal'
                }
              )
            }
          }); */
          this.getOrganizationData();
          
          this.notificationService.getAllFromRedis(this.userInfo.Id).subscribe();
          this.pushy.subscribeToPushy(info.SFAccountID).then(() => {
            this.pushNotificationListeners();
          });
        }
      }
    );
  }

  private async loadSalesforceChatComponent(): Promise<void> {
    if (!this.userInfo || !this.isLoggedIn || this.salesforceChatComponentLoaded) {
      if (this.salesforceChatComponentRef) {
        this.salesforceChatComponentRef.setInput('userInfo', this.userInfo);
      }
      return;
    }

    const host = this.salesforceChatHost;
    if (!host) {
      return;
    }

    const { SalesforceChatComponent } = await import('./shared/components/salesforce-chat/salesforce-chat.component');
    host.clear();
    this.salesforceChatComponentRef = host.createComponent(SalesforceChatComponent);
    this.salesforceChatComponentRef.setInput('userInfo', this.userInfo);
    this.salesforceChatComponentLoaded = true;
  }

  private clearSalesforceChatComponent(): void {
    this.salesforceChatComponentRef?.destroy();
    this.salesforceChatComponentRef = undefined;
    this.salesforceChatComponentLoaded = false;
    this.salesforceChatHost?.clear();
  }

  getOrganizationData(): void {
    this.organizationService.getAvailableCountries().subscribe(
      (res) => {
        //console.log('ORG DATA:', res);
        let organization = this.userInfo.OrganizationLowerCase;
        res.body.forEach(org => {
          if (org.name === organization) {
            this.changeLangService.setAvailableLangs(org.languages);
          }
        });
      }
    )
  }

  pushNotificationListeners() {
    if (this.pushNotificationListenerRegistered || !this.isPushySupported()) {
      return;
    }

    // Listen for push notifications
    try {
      Pushy.setNotificationListener((data) => {
        // Print notification payload data
        //console.log('Received notification test: ' + JSON.stringify(data));
        //alert('Received notification: ' + JSON.stringify(data))
        let time = new Date().getTime();
        let id = data.id || this.helpers.generateRandomString(16); 
        let message = data.message; // string
        let category = data.category.toLowerCase(); // string
        let title = data.title || '';
        let path = data.path;
        // save notification in local storage
        // save notification in db
        const notification = {
          path,
          time,
          id,
          message,
          category,
          title,
          seen: false
        }
        this.ngZone.run(() => {
          // Bring event back inside Angular's zone
          if (category) {
            //alert('saving notification: ' + JSON.stringify(notification));
            let info = this.userBasicService.basicInfoValue();

            if (info) {
              this.notificationService.save(info.Id, id, notification).subscribe();
              this.userInfo = info;
            } else {
              this.userBasicService.basicInfo().subscribe(
                (res) => {
                  this.userInfo = res;
                  let accountId = res.Id;
                  this.notificationService.save(accountId, id, notification).subscribe();
                });
            }
          }

        });
        // Display an alert with the "message" payload value
        //alert('Received notification: ' + data.message);

      });
      this.pushNotificationListenerRegistered = true;
    } catch (error) {
      console.warn('Pushy notification listener unavailable for this runtime.', error);
    }
  }

  private isPushySupported(): boolean {
    if (typeof window === 'undefined' || typeof navigator === 'undefined') {
      return false;
    }

    const hasWebPushApis = 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;
    if (!hasWebPushApis) {
      return false;
    }

    const isIos = /iPad|iPhone|iPod/i.test(navigator.userAgent);
    if (!isIos) {
      return true;
    }

    return window.matchMedia?.('(display-mode: standalone)').matches || (navigator as any).standalone === true;
  }

  async presentToastLang(message: string): Promise<any> {
    const toast = await this.toastController.create({
      message,
      duration: 10000,
      buttons: [
        {
          text: this.translate.instant('Close'),
          role: 'cancel',
        }
      ]
    });
    toast.present();
  }

  switchTheme(theme: string) {
    this.theme.setActiveTheme(theme);
  }

  switchLang(lang: string): void {
    this.changeLangService.setLang(lang);
  }

  logout(): void {
    this.isLoggedIn = false;
    this.showMenu = false;
    this.mobileMenu = false;
    this.menuOpen = true;
    this.submenuOpen = false;
    this.menuCtrl.enable(false);
    this.clearSalesforceChatComponent();
    this.auth.logout();
  }

  openActions() {
    this.showActions = !this.showActions;
  }

  toggleMenu() {
    this.menuOpen = !this.menuOpen;
    if(this.menuOpen) {
      if(this.langDirection === 'ltr'){
        this.menuArrow = 'chevron-back-outline'
      } else {
        this.menuArrow = 'chevron-forward-outline'
      }
      
    } else {
      if(this.langDirection === 'ltr'){
        this.menuArrow = 'chevron-forward-outline'
      } else {
        this.menuArrow = 'chevron-back-outline'
      }
    }
  }
  
  redirect(url){
    window.location.href = url + this.redirectUrlDetails;
  }

  onPageClicked(page) {

    if(page === null) {
      this.submenuOpen = false;
      this.appPages.map( p => {
        if(p.open){
          p.open = false;
        }
      })
      return;
    }
    
    this.appPages.map( p => {
      if(p.open && p.id !== page.id){
        p.open = false;
        this.submenuOpen = false;
      }
    })
    if(page.open && !this.submenuOpen){
      this.submenuOpen = true;
    } else {
      page.open = !page.open;
      this.submenuOpen = !this.submenuOpen;
    }
    this.activePage = page;
    if (page.open) this.showActions = false;
    else this.showActions = this.showActions;
  }

  presentBottomModal(page: string) {
    if(!page){
      this.selectedSubMenu = null;
      return;
    }

    this.activePage = this.appPages.find(p => p.title === page);
    //this.openBottomModal = !this.openBottomModal;
    this.bottomModal.present();
  }

  subMenuSelected(page: any) {
    this.selectedSubMenu = page;
    this.router.navigate([page.url])
    this.bottomModal.dismiss();
  }
}
